export const PTO_PROJECT_DETAILED_PROJECT_ROUTE_NAME = [
  'PtoProjectUpdate',
  'PtoProjectChange',
  'PtoProjectDocument',
  'PtoProjectStatement'
]
